const mobileStyles = `

.header {
    /* display: flex; */
    position: relative;
    /* align-items: center; */
    /* justify-content: space-between; */
    background: var(--header-bg);
    height: 50px;
    color: var(--header-text);
    border-bottom: var(--header-border-bottom);
    width: 100%;
  }
  
  .menu {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 12px;
    height: 100%;
    margin-right: 15px;
    z-index: 10000;
  }
  
  .active {
    background: var(--toggle-active);
  }
  
  .header-content {
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .left {
    display: flex;
    align-items: center;
  }
  
  .left svg {
    fill: var(--header-text);
  }
  
  .right {
    margin-right: 10px;
  }
  
  .submenu-wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    height: 100vh;
    border-top: none;
    overflow-x: hidden;
    overflow-y: auto !important;
    z-index: 100000;
    width: 100%;
    background: var(--sm-bg);
    top: 34px;
    color: var(--text-color);
    font-weight: normal;
    cursor: pointer !important;
  }
  
  .nav-item {
    position: relative;
    padding: 15px 0px 15px 1px;
    border-bottom: var(--header-border-bottom);
    width: 100%;
  
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
  }
  
  /* .inner-nav {
    padding: 15px 7px 15px 0px !important;
  } */
  
  /* .nav-item-inner {
    position: relative;
    padding: 15px 7px 15px 7px;
    border-bottom: var(--header-border-bottom);
    width: 100%;
  } */
  
  .top:first-child {
    margin-top: 15px;
    border-top: var(--header-border-bottom);
  }
  
  /* .first:first-child {
      
  } */
  
  .drop-down {
    position: absolute;
    right: 17px;
    top: 11px;
    /* left: 15px; */
  }
  
  .drop-down-inner {
    position: absolute;
    right: 20px;
  }
  
  .external-link {
    position: absolute;
    right: 23px;
  }
  
  .nav-text-inner {
    margin-left: 25px;
    font-weight: normal !important;
    display: block;
    width: 100%;
  }
  
  .nav-text-link {
    margin-left: 35px;
  }
  
  .nav-text {
    margin-left: 18px;
    display: block;
    width: 100%;
  }
  
  .action-drop-text {
    margin-left: 10px;
  }
  
  .nav-item:last-child {
    border-bottom: none;
  }
  
  .menu-item {
    /* background: var(--toggle-active); */
  }
  
  .active-menu {
    background: var(--sub-menu-bg) !important;
  }
  
  .active-inner {
    background: transparent !important;
  }
  
  .active-inner span {
    font-weight: bold !important;
  }
  
  .input {
    width: 100%;
    padding: 12px 30px 12px 12px;
    margin: 0px 5px 0px 5px;
    background: var(--input-bg);
    border: var(--input-border);
    border-radius: var(--border-radius);
  }
  
  .input:focus {
    border-color: var(--nav-hover);
    outline: 0 none;
  }
  
  .input-form {
    position: relative;
    margin-top: 10px;
  }
  
  .input-form svg {
    position: absolute;
    right: 12px;
    top: 12px;
    fill: var(--input-placeholder-color);
  }
  
  input::placeholder {
    color: var(--input-placeholder-color);
  }
  
  .inner-group {
    margin: 0;
  }
  
  .inner-nav {
    background: var(--sm-bg);
  }
  
  .inner-nav:last-child {
    /* padding-bottom: 100px; */
  }
  
  .quick-links {
    background: transparent;
    display: flex;
    flex-wrap: wrap;
  
    align-items: center;
  }
  
  .quick-links-item {
    display: flex;
    align-items: center;
    width: auto;
    padding: 20px;
  }
  
  .quick-links-icon {
    margin-right: 10px;
  }
  
  .flex-col {
    width: 100%;
    padding: 25px;
    display: flex;
    flex-direction: column;
  }
  
  .language-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
    justify-content: space-between;
  }
  
  .language-item:hover {
    color: var(--nav-hover);
  }
  
  .language-name {
    margin-left: 10px;
  }
  
  .language-item .right {
    display: flex;
    align-items: center;
  }
  
  .info-group svg {
    fill: var(--header-text);
    /* width: 16px;
    height: 17px; */
  }
  
  .btn {
    width: 100%;
    height: 40px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: capitalize;
    border: none;
    transition: all 0.2s ease-in-out;
  }
  
  .btn:hover {
    transform: scale(1.02);
  }
  
  .btn svg {
    fill: inherit;
    margin-right: 10px;
  }
  
  .clock-out {
    background: var(--clock-out-bg);
    color: var(--clock-text);
  }
  
  .btn-main {
    background: var(--btn-main-bg);
    color: var(--btn-main-text);
  }
  
  .btn-main svg {
    fill: var(--btn-main-text);
  }
  
  .clock-out svg {
    fill: var(--clock-svg);
  }
  
  .search-container {
    width: 100%;
    position: fixed;
    z-index: 200000;
  }
  
  .search-drop-down {
    background: var(--nav-bg);
    height: 100vh;
    width: 100%;
    border-top: none;
    overflow-x: auto;
    overflow-y: auto !important;
    z-index: 100000;
    top: 50px;
    color: var(--text-color);
    padding: 10px 15px 10px 15px;
    position: absolute;
  }
  
  .s-quick-links {
    display: flex;
    flex-direction: column;
  }
  
  .s-quick-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 15px 20px 32px;
    border-bottom: 0.5px solid var(--s-result-border-color);
  }
  


`;

export default mobileStyles;
